import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la/'
import { laChannelCount, laDiscountPriceMonthly } from 'src/constants/planData/latinoPlanData'
import { promoCodes } from 'src/constants'

export default (props) => {
  return (
    <LatinoTemplateDefault
      location={props.location}
      lang="es"
      market="latino"
      poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Web.jpg"
      posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/LaLiga_Ver1_Mobile.jpg"
      logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-western-union.png"
      title={
        <>
          Ahorra en TV <span className="no-wrap">en vivo para</span>{' '}
          <span className="no-wrap">toda la familia</span>
        </>
      }
      subtitle={
        <>
          Más de {laChannelCount} canales con deportes, noticias y{' '}
          <span className="desktop-line-break">
            entretenimiento en español desde solo{' '}
            <span className="green-underline">${laDiscountPriceMonthly}</span> los primeros dos
            meses.
          </span>
        </>
      }
      networkSet={'entertainmentLatino'}
      offerCode={promoCodes.western_union}
      noteLink="/la/western-union/"
      cardFootnote={
        <>
          *Oferta válida por los primeros dos meses. Se renueva a $14.99/mes. Pueden aplicarse
          impuestos y otros cargos.{' '}
          <span className="desktop-line-break">
            Precios sujetos a cambios. Cancela cuando quieras.
          </span>
        </>
      }
    />
  )
}
